import { render } from "./InkboardTitle.vue?vue&type=template&id=b1d0945a&scoped=true&ts=true&lang=pug"
import script from "./InkboardTitle.vue?vue&type=script&lang=ts"
export * from "./InkboardTitle.vue?vue&type=script&lang=ts"

import "./InkboardTitle.vue?vue&type=style&index=0&id=b1d0945a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1d0945a"]])

export default __exports__